var _rect, _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValueClick = function SvgValueClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 244,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 244,
    fill: "#FAFAFC",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#value_click_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232,
    height: 125,
    x: 40,
    y: 60,
    fill: "#fff",
    rx: 16
  }), /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 124,
    x: 40.5,
    y: 60.5,
    stroke: "#E3E6EB",
    rx: 15.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 12,
    x: 56,
    y: 77,
    fill: "#E3E6EB",
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 71,
    x: 56,
    y: 101,
    fill: "#EBF7FF",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 62,
    x: 60.5,
    y: 105.5,
    stroke: "#25A0F6",
    rx: 11.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 8,
    x: 74,
    y: 119,
    fill: "#26A0F6",
    opacity: 0.25,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 8,
    x: 74,
    y: 133,
    fill: "#26A0F6",
    opacity: 0.25,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 8,
    x: 74,
    y: 147,
    fill: "#26A0F6",
    opacity: 0.25,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m225.083 144.959 19.834 11.617-8.784 2.125-3.683 11.05z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#value_click_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    x: 247,
    y: 45,
    fill: "#21C45E",
    rx: 19
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m260 64.3 3.9 3.9 8.1-8.4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "value_click_svg__a",
    width: 252,
    height: 145,
    x: 30,
    y: 52,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_2889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_236_2889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "value_click_svg__b",
    width: 58,
    height: 58,
    x: 237,
    y: 35,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_2889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_236_2889",
    result: "shape"
  })))));
};
export default SvgValueClick;